import { z } from 'zod';
import { billingCurrencies } from './billing.js';
import { normalizeName } from './people.js';

/**
 * The club's own data: its name, the language its e-mails are written in, the time zone its calendar
 * days follow, and the currency new billing accounts, fee plans and yearly fees use. Changing the
 * currency never touches existing billing accounts: their entries stay in the currency they were
 * posted in.
 */
export const updateClubDataRequestSchema = z.strictObject({
  name: z.string().transform(normalizeName).pipe(z.string().min(1).max(200)),
  defaultLocale: z.enum(['en', 'hu', 'ro']),
  timezone: z.string().trim().min(1).max(64),
  currency: z.enum(billingCurrencies),
});
export type UpdateClubDataRequest = z.infer<typeof updateClubDataRequestSchema>;

export interface ClubDataView {
  name: string;
  defaultLocale: string;
  timezone: string;
  currency: string;
  /** Organization row version; send it in `If-Match` when saving. */
  version: number;
}
